import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const MyChallengesPlaceholder = props => (
  <Wrapper>
    <ContentLoader width={616} height={460} speed={3} primaryColor="#ebecef" secondaryColor="#d1d2db" {...props}>
      <rect x="32" y="32" rx="4" ry="4" width="128" height="8" />
      <rect x="488" y="32" rx="4" ry="4" width="96" height="8" />
      <rect x="32" y="48" rx="4" ry="4" width="208" height="24" />
      <rect x="444" y="48" rx="4" ry="4" width="140" height="24" />
      <rect x="456" y="88" rx="4" ry="4" width="128" height="24" />
      <rect x="32" y="88" rx="4" ry="4" width="144" height="8" />
      <rect x="32" y="128" rx="12" ry="12" width="96" height="24" />
    </ContentLoader>
  </Wrapper>
);

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  background-color: #f9f9fa;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

export default MyChallengesPlaceholder;



// WEBPACK FOOTER //
// ./src/components/ui/layout/spinner/my-challenges-placeholder.jsx